// ─────────────────────────────────────────────────────────────────────────
// Amanar brand theme — shared across products (gotraceit.ai palette).
//
// This is the single source of truth for colors. Import it everywhere instead
// of hardcoding hex values:
//     import { theme } from './theme';
//
// To keep multiple Amanar products visually consistent, copy this file into
// each product. Change the palette once here, then sync.
// ─────────────────────────────────────────────────────────────────────────

export const theme = {
  // Backgrounds
  bg:          '#0F172A',  // slate-900 — primary page background (deep navy)
  surface:     '#1E293B',  // slate-800 — cards, panels, table rows
  surfaceAlt:  '#334155',  // slate-700 — hover states, elevated surfaces, borders

  // Accents
  primary:      '#3B82F6',  // blue-500 — primary buttons, links, active states
  primaryHover: '#2563EB',  // blue-600 — primary button hover
  accent:       '#10B981',  // emerald-500 — success, "high value" highlights
  accentMute:   '#064E3B',  // emerald-900 — accent backgrounds (low key)
  danger:       '#EF4444',  // red-500 — errors, destructive actions
  warning:      '#F59E0B',  // amber-500 — caution / pending states

  // Text
  heading:  '#FFFFFF',  // white — headings, emphasis
  text:     '#CBD5E1',  // slate-300 — body text
  textMute: '#94A3B8',  // slate-400 — muted / secondary text

  // Borders
  border: '#334155',  // slate-700
};

// Status colors for lead lifecycle (Milestone 2) — keyed by assignment status.
export const statusTheme = {
  new:        { fg: theme.text,     bg: theme.surfaceAlt },
  contacted:  { fg: '#3B82F6',      bg: '#1E3A5F' },       // blue tint
  qualified:  { fg: theme.accent,   bg: theme.accentMute },// emerald
  won:        { fg: theme.accent,   bg: theme.accentMute },
  lost:       { fg: theme.danger,   bg: '#3F1D1D' },       // red tint
  not_a_fit:  { fg: theme.textMute, bg: theme.surface },   // muted
};
